import orderBy from "lodash/orderBy";

import AddOnOffer from "./AddOnOffer";
import styles from "./AddOnOffers.module.scss";
import strings from "./strings";
import Props from "./types";

function AddOnOffers({ addOns }: Props): JSX.Element | null {
  if (!addOns?.length) {
    return null;
  }

  // Ensure that All-Access is shown first
  const sortedAddOns = orderBy(addOns, "name", "desc");

  return (
    <div className={styles.container}>
      <span className={styles.title}>{strings.title}</span>
      <span className={styles.subTitle}>{strings.subTitle}</span>
      <span className={styles.bestValue}>{strings.bestValue}</span>
      <div className={styles.offers}>
        {sortedAddOns?.map((addOn, idx) => (
          <AddOnOffer addOn={addOn} key={idx} />
        ))}
      </div>
    </div>
  );
}

export default AddOnOffers;
